exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comment-section{position:relative}.comment-section .comment-users-list{position:absolute;width:100%;z-index:999;top:40%}.comment-section .tiptap-vuetify-editor__content{height:130px!important}.comment-section .v-input__control{height:20px}", ""]);

// exports
